import Imprint from './Imprint';
import PatientStatistics from './PatientStatistics';
import LivingStatus from './LivingStatus';
import Age18 from './Age18';
import IgReplacement from './IgReplacement';
import HSCTReplacement from './HSCTReplacement';
import PIDDistribution from './PIDDistribution'
import GenderChartPublic from './GenderChartPublic'
import Gender from './Gender'
import ExternalCenters from '../ExternalCenters'


export {
  Imprint,
  PatientStatistics,
  LivingStatus,
  Age18,
  IgReplacement,
  HSCTReplacement,
  PIDDistribution,
  Gender,
  GenderChartPublic,
}




// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Sections/index.js